import React, { useEffect, useState } from 'react';

import { Flex } from '../../styles/globalStyles';
import { FooterBannerArea } from '../../styles/layOutStyles';
import { useHistory } from 'react-router';
import useInterval from '../../helpers/useInterval';

import { textSilce } from '../../constants/index';

const NoticeBanner = ({ data }) => {
  const history = useHistory();

  const [createNoticeBanner, setCreateNoticeBanner] = useState(false);

  const [pagination, setPagination] = useState('');
  const [swiper, setSwiper] = useState('');
  const [ele, setEle] = useState('');
  const [max, setMax] = useState(0);

  const [height, setHeight] = useState(0);

  let move = 0;
  let cnt = 1;

  useEffect(() => {
    if (data && data.length > 0) {
      setMax(data.filter(a => a?.alwaysTop).length);
    }
  }, [data]);

  useEffect(() => {
    if (max) {
      let _pagination;
      let _swiper;
      let _ele;

      _ele = document.getElementById('noticeBannerFilcking');
      _pagination = document.createElement('div');
      _swiper = document.getElementById('noticeBannerCamera');
      _pagination.id = 'noticeBannerPagination';

      let height = _ele.clientHeight;

      _pagination.innerHTML = `<p>${cnt} / ${max}</p>`;
      _ele.appendChild(_pagination);
      setPagination(_pagination);
      setSwiper(_swiper);
      setEle(_ele);
      setHeight(height);

      setCreateNoticeBanner(true);
    }
  }, [max]);

  // Auto Play ...
  useInterval(() => {
    if (createNoticeBanner) {
      up();
    }
  }, 3000);

  const up = () => {
    if (max) {
      if (cnt >= max) {
        move = 0;
        cnt = 1;
      } else {
        cnt++;
        move += height;
      }

      pagiantionChange(cnt, max, move);
    }
  };
  const down = () => {
    if (max) {
      if (cnt <= 1) {
        move = height * (max - 1);
        cnt = max;
      } else {
        cnt--;
        move -= height;
      }

      pagiantionChange(cnt, max, move);
    }
  };

  const pagiantionChange = (_cnt, _max, _move) => {
    pagination.innerHTML = `<p>${_cnt} / ${_max}</p>`;
    swiper.style.transform = `translate(0px, ${_move * -1}px)`;
    ele.appendChild(pagination);
  };

  const renderList = list => {
    return list
      .filter(a => a?.alwaysTop)
      .map((item, idx) => {
        return (
          <Flex key={`noticeBanner_${idx}`} className='noticeBannerItems'>
            <h1>공지사항</h1>
            <h2 onClick={() => goDetail(item)}>{textSilce(item.title, 60)}</h2>
            <h2></h2>
          </Flex>
        );
      });
  };

  const goDetail = data => {
    history.push(process.env.PUBLIC_URL + `/help-detail?id=${data.id}&type=notice&tab=0`, { link: true });
  };

  return (
    <FooterBannerArea>
      {data && (
        <div id='noticeBannerFilcking'>
          <div id='noticeBannerCamera' style={{ transform: 'translate(0, 0)' }}>
            {data.length > 0 && renderList(data)}
          </div>
          {createNoticeBanner && (
            <div id='noticeBannerBtnGroup'>
              <span onClick={up} />
              <span onClick={down} />
            </div>
          )}
        </div>
      )}
    </FooterBannerArea>
  );
};

export default NoticeBanner;
